// Silly, animated, over-the-top Phaser 3 "Game Won" scene
export class GameWonScene extends Phaser.Scene {
  constructor() {
    super("GameWonScene");
  }

  preload() {
    this.load.image(
      "confetti",
      "https://labs.phaser.io/assets/particles/yellow.png",
    );
    this.load.image("clown", "https://labs.phaser.io/assets/sprites/clown.png");
    this.load.audio(
      "victory",
      "https://labs.phaser.io/assets/audio/SoundEffects/p-ping.mp3",
    );
    this.load.spritesheet(
      "dancer",
      "https://labs.phaser.io/assets/sprites/chick.png",
      {
        frameWidth: 64,
        frameHeight: 64,
      },
    );
  }

  create() {
    this.sound.play("victory");

    // Smooth background color gradient transition (slowed down by 3x)
    const colors = ["#ff69b4", "#ffff00", "#00ffff", "#ff00ff"];
    let colorIndex = 0;

    // Set initial background color
    this.cameras.main.setBackgroundColor(colors[0]);

    // Function to interpolate between two hex colors
    const interpolateColor = (color1, color2, factor) => {
      // Convert hex to RGB
      const r1 = parseInt(color1.substring(1, 3), 16);
      const g1 = parseInt(color1.substring(3, 5), 16);
      const b1 = parseInt(color1.substring(5, 7), 16);

      const r2 = parseInt(color2.substring(1, 3), 16);
      const g2 = parseInt(color2.substring(3, 5), 16);
      const b2 = parseInt(color2.substring(5, 7), 16);

      // Interpolate RGB values
      const r = Math.round(r1 + factor * (r2 - r1));
      const g = Math.round(g1 + factor * (g2 - g1));
      const b = Math.round(b1 + factor * (b2 - b1));

      // Convert back to hex
      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    };

    // Create a timer event that cycles through colors with smooth transitions
    this.time.addEvent({
      delay: 900, // 3x slower than original 300ms
      callback: () => {
        const currentColor = colors[colorIndex];
        const nextColorIndex = (colorIndex + 1) % colors.length;
        const nextColor = colors[nextColorIndex];

        // Create a tween to smoothly transition between colors
        const duration = 900; // Same as delay for continuous transition
        const steps = 20; // Number of steps for smooth transition
        const stepTime = duration / steps;

        for (let i = 0; i < steps; i++) {
          this.time.delayedCall(i * stepTime, () => {
            const factor = i / (steps - 1);
            const interpolatedColor = interpolateColor(currentColor, nextColor, factor);
            this.cameras.main.setBackgroundColor(interpolatedColor);
          });
        }

        // Update color index for next cycle
        colorIndex = nextColorIndex;
      },
      loop: true,
    });

    // Text Explosion
    const text = this.add
      .text(window.innerWidth / 2, 400, "YOU WON!", {
        fontSize: "100px",
        fontFamily: "Comic Sans MS",
        color: "#ffffff",
        stroke: "#000000",
        strokeThickness: 10,
      })
      .setOrigin(0.5);
    this.tweens.add({
      targets: text,
      scale: { from: 0.5, to: 2 },
      yoyo: true,
      repeat: -1,
      ease: "Bounce.easeInOut",
      duration: 1000,
    });

    this.add.particles(0, 0, "confetti", {
      x: { min: 0, max: window.innerWidth },
      y: 0,
      lifespan: 4000,
      speedY: { min: 200, max: 400 },
      scale: { start: 0.5, end: 0 },
      quantity: 10,
      blendMode: "ADD",
    });

    // Clown that flies across screen every 2 seconds
    this.time.addEvent({
      delay: 2000,
      callback: () => {
        const clown = this.add.image(
          -100,
          Phaser.Math.Between(100, 500),
          "clown",
        );
        this.tweens.add({
          targets: clown,
          x: 900,
          duration: 3000,
          ease: "Cubic.easeInOut",
          onComplete: () => clown.destroy(),
        });
      },
      loop: true,
    });

    // Dancing sprite
    this.anims.create({
      key: "dance",
      frames: this.anims.generateFrameNumbers("dancer", { start: 0, end: 3 }),
      frameRate: 6,
      repeat: -1,
    });
    // const dancer = this.add.sprite(400, 300, "dancer").play("dance");
    // this.tweens.add({
    //   targets: dancer,
    //   angle: { from: -20, to: 20 },
    //   yoyo: true,
    //   repeat: -1,
    //   duration: 400,
    // });
    this.sound.stopAll();
    this.sound.add("win", { volume: 1 }).play();
  }
}
